/**
 * Stars, drawn from a value on a 0–`max` scale.
 *
 * Half-steps matter: a 4.4 and a 4.6 rounded to the same four stars would hide
 * exactly the difference a ranking turns on, so the partial star is clipped to
 * the real fraction rather than rounded.
 *
 * Lifted out of `rankedColumns` when ratings became a value *format* any tile
 * can ask for (see `valueFormat.ts`) rather than something one template drew.
 * One implementation, so the KPI tile and the leaderboard cannot drift apart.
 *
 * The number stays in `aria-label` — a screen reader gets "4.2 out of 5", not
 * five star glyphs, and the figure is still the thing being communicated.
 */
export const Stars = ({ value, max = 5 }: { value: number; max?: number }) => {
  const safeMax = max > 0 ? max : 5;
  const pct = Math.max(0, Math.min(1, value / safeMax)) * 100;
  const glyphs = '★'.repeat(Math.round(safeMax));

  return (
    <span className="stars" role="img" aria-label={`${value.toFixed(1)} out of ${safeMax}`}>
      <span className="stars__track" aria-hidden="true">
        {glyphs}
      </span>
      <span className="stars__fill" style={{ width: `${pct.toFixed(1)}%` }} aria-hidden="true">
        {glyphs}
      </span>
    </span>
  );
};
